import React from 'react';
import ReactDOM from 'react-dom/client';
import WorkspaceRouter from '@/pages/Workspace';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <WorkspaceRouter />
);